import Loadable from "@cores/loadable";

const LoadableEtcFileDetail = Loadable({
    loader: () => import('./EtcFileDetail'),
    loading: () => null
});

export default LoadableEtcFileDetail;
